import type { ColumnDef } from "@tanstack/react-table"
import { Check, X } from "lucide-react"

import type { IRetentionOfferCycle } from "@commonTypes/offer"
import { ButtonCell, DateCell } from "@utils/table/columnFactories"

import { useAccountOfferFunnel } from "./useAccountOfferFunnel"
import type { TFunnelOffer } from "./offerTypeGuards"

export const useChooseOfferColumns = <
  T extends TFunnelOffer,
>(): ColumnDef<T>[] => {
  const { setStep, setSelectedOffer } = useAccountOfferFunnel()

  return [
    {
      header: "Offer",
      accessorKey: "offer_desc",
      cell: (props) => {
        const offer = props.row.original
        return (
          <div className="tw:flex tw:justify-between">
            <span>{offer.offer_desc}</span>
            <ButtonCell
              {...props}
              variant="default"
              label="View Offer"
              onClick={() => {
                setStep("offerDetail")
                setSelectedOffer(offer)
              }}
            />
          </div>
        )
      },
    },
    {
      header: "Rate",
      accessorKey: "rate",
    },
  ]
}

export const retentionRateTableColumns: ColumnDef<IRetentionOfferCycle>[] = [
  {
    header: "From Date",
    accessorKey: "cycle_from_dt",
    cell: (props) => <DateCell {...props} />,
  },
  {
    header: "To Date",
    accessorKey: "cycle_to_dt",
    cell: (props) => <DateCell {...props} />,
  },
  {
    header: "Rate",
    accessorKey: "rate",
  },
  {
    header: "Available Rate Change",
    accessorKey: "is_retention_rate",
    cell: ({ row }) => {
      const rowData = row.original
      return rowData.is_retention_rate ? (
        <Check className="tw:text-green-500" />
      ) : (
        <X className="tw:text-destructive" />
      )
    },
  },
]
